<div
    class="agpr-formField agpr-textField"
    [ngClass]="{ 'agpr-dateRangeField--hidden': !showPicker }"
>
    <label
        *ngIf="field.label"
        class="agpr-formField-heading agpr-formField-label"
        [id]="id + '-label'"
    >
        {{ field.label | localize }}
    </label>
    <agpr-date-query-popup
        #dateQueryPopup
        [id]="id"
        [(ngModel)]="dateRange"
        [options]="dateFilterOptions"
        [searchRange]="(showAllOption || (this.block && gaChartType[this.block.type.key])) ? null : searchRange"
        [dateTypeOptions]="dateTypeOptions"
        [hideDateTypeSelection]="hideDateTypeSelection"
        (ngModelChange)="dateRangeChanged($event)"
        [ariaLabelledBy]="field.label ? id + '-label' : null"
    >
    </agpr-date-query-popup>
    <div
        *ngIf="field.description"
        class="agpr-formField-description"
    >
        {{ field.description | localize }}
    </div>
</div>
